import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import React, { memo, useRef } from 'react';
import Popup from '../Popup';
import MenuItem from '../MenuItem';

var Menu = function (props) {
  var options = props.options,
      divider = props.divider,
      restProps = _objectWithoutPropertiesLoose(props, ["options", "divider"]);

  var popupRef = useRef();
  return /*#__PURE__*/React.createElement(Popup, _extends({}, restProps, {
    ref: popupRef
  }), options.map(function (item, index) {
    var name = item.name,
        id = item.id,
        _onClick = item.onClick,
        _item$closeOnClick = item.closeOnClick,
        closeOnClick = _item$closeOnClick === void 0 ? true : _item$closeOnClick,
        dividerItem = item.divider,
        rest = _objectWithoutPropertiesLoose(item, ["name", "id", "onClick", "closeOnClick", "divider"]);

    var defaultDivider = divider && index !== options.length - 1;
    return /*#__PURE__*/React.createElement(MenuItem, _extends({
      id: id,
      key: id,
      name: name,
      onClick: function onClick(e) {
        var _popupRef$current;

        _onClick == null ? void 0 : _onClick(item, e); // @ts-ignore

        if (closeOnClick) (_popupRef$current = popupRef.current) == null ? void 0 : _popupRef$current.close();
      },
      divider: defaultDivider || dividerItem
    }, rest));
  }));
};

export default /*#__PURE__*/memo(Menu); // @ts-ignore

export var MenuOption = function () {
  return null;
};